// ./src/components/features/CreateEventWizard/steps/PlaceholderStep.tsx
//
// A stand-in panel for steps not yet built, so the whole flow is walkable in the
// mockup. Shows what the wizard has captured so far, which is handy for verifying
// the draft + persistence plumbing end to end.

import React from 'react';
import { Stack, Text, Card, Code, ThemeIcon } from '@mantine/core';

import { AppIcon } from '@/components/generic';

import { useEventWizard } from '../WizardContext';
import { useOptionalEventSetupCatalogContext } from '@/contexts/EventSetupCatalogContext';

export interface PlaceholderStepProps {
  label: string;
}

export const PlaceholderStep: React.FC<PlaceholderStepProps> = ({ label }) => {
  const { draft } = useEventWizard();
  const type = useOptionalEventSetupCatalogContext()?.findType(draft.eventCategoryId) ?? null;

  return (
    <Stack gap="lg" align="center" py="xl">
      <ThemeIcon variant="light" color="brand" size={56} radius="xl">
        <AppIcon iconName="Tools" size={28} />
      </ThemeIcon>
      <Stack gap={4} align="center">
        <Text fw={600}>{label}</Text>
        <Text size="sm" c="dimmed" ta="center" maw={360}>
          This step is coming next. Use Back / Next to walk the flow — your progress is saved as you go.
        </Text>
      </Stack>

      <Card withBorder radius="md" w="100%" maw={420} padding="md">
        <Text size="xs" fw={600} c="dimmed" tt="uppercase" mb="xs">
          Draft so far
        </Text>
        <Stack gap={6}>
          <Text size="md">
            Type:{' '}
            {type ? (
              <Text span fw={600}>
                {type.emoji} {type.name}
              </Text>
            ) : (
              <Text span c="dimmed">
                not chosen
              </Text>
            )}
          </Text>
          <Code block>{JSON.stringify(draft, null, 2)}</Code>
        </Stack>
      </Card>
    </Stack>
  );
};
